module.exports = __webpack_public_path__ + "assets/fonts/Roboto-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Roboto-Regular.ttf
// module id = 408
// module chunks = 0